import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common.service';
import * as moment from 'moment/moment';
import { GetAnnouncementStatusDescription, GetAnnouncementTypeDescription } from '../utils/announcement-utils';
import { Announcement, AnnouncementList } from 'announcement-api';
import { ModalComponent } from "../modal/modal.component";
import { Profile } from 'profile-api';
import { InlineResponse200 } from "profile-api";

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.css']
})
export class AnnouncementsComponent implements OnInit {
  @ViewChild("confirmationModal") confirmationModal: ModalComponent;
  @ViewChild("denialModal") denialModal: ModalComponent;
  
  profile: Profile = {};
  provinceList;
  pageSize: number = 10;
  pageNumber: number = 0;
  currentStatuses: string = "DRAFT,APPROVAL,PUBLISHED"; // REFUSED,OFFER_REFUSED,OFFER_ACCEPTED
	openedAnnouncementCards: Array<Announcement> = [];
	closedAnnouncementCards: Array<Announcement> = [];
  showMore: boolean = true;
  isHistoryView: boolean = false;
  goToClosedLinkLabel: string = "VAI ALLO STORICO ANNUNCI CHIUSI";
  backLinkLabel: string = "TORNA AGLI ANNUNCI APERTI";
  emptyLabel: string = "";
  showMoreLabel: string = "ALTRI ANNUNCI";
  confirmationModalMsg: string;
  confirmationModalSubmitMsg: string;
  confirmationModalAnnouncementId: number;

  constructor(
    private commonService: CommonService,
    private router: Router
  ) { }

  ngOnInit(): void {
    window['moment'] = moment;
    this.commonService
    .getProvinces()
    .then((provinceList: InlineResponse200) => {
      this.provinceList = provinceList;
    })
    .catch((error) => {
      console.log(error);
    });
    this.loadCurrent();
  }

  loadCurrent() {
    this.pageNumber = 0;
    this.loadCurrentList();
  }

  loadClosed() {
    this.pageNumber = 0;
    this.loadClosedList();
  }

  loadCurrentList() {
    this.isHistoryView = false;
    this.closedAnnouncementCards = [];
    this.commonService.getAnnouncementsService().announcementGet(
			this.pageSize,
			this.pageNumber,
      null, 
      null,
      null, 
      this.currentStatuses
		).subscribe(
			(res: AnnouncementList) => {
				console.log('Current announcements: ');
				console.log(res);

				this.openedAnnouncementCards = this.openedAnnouncementCards.concat(res.announcements);

				this.showMore = res.paging.pageNumber < (res.paging.totalPages - 1);
				this.closedAnnouncementCards = [];
				this.emptyLabel = "Nessun annuncio presente";
			},
			error => {
				console.error(error);
			}
		);
  }

  getFormattedDate(date: string) {
    return moment(date).format('DD-MM-YYYY');
  }
  
  getStatusDescription(statusCode: string) {
    return GetAnnouncementStatusDescription(statusCode);
  }

  getTypeDescription(typeCode: string) {
    return GetAnnouncementTypeDescription(typeCode);
  }


  loadMore() {
    this.pageNumber = this.pageNumber + 1;
    if (this.isHistoryView) {
      this.loadClosedList();
    } else {
      this.loadCurrentList();
    }
  }

  deleteAnnouncement(card: Announcement) {
    this.confirmationModalMsg = "Si è sicuri di voler eliminare l'annuncio?";
    this.confirmationModalSubmitMsg = "ELIMINA";
    this.confirmationModalAnnouncementId = card.announcementId;
    this.confirmationModal.open();
  }
  
  confirmationModalSubmit() {
    if (this.confirmationModalAnnouncementId) {
      this.commonService.getAnnouncementsService().announcementAnnouncementIdDelete(
        this.confirmationModalAnnouncementId
      ).subscribe(
        () => {
          console.log('Announcement deleted ');
          this.openedAnnouncementCards = [];
          this.loadCurrentList();
        },
        error => {
          // console.error(error);
          this.openedAnnouncementCards = [];
          this.loadCurrentList();
        }
      );
      this.confirmationModal.close();
    }
  }

  createAnnouncement(){
    this.commonService.getProfile().then((profile: Profile) => {
      if (!profile.announcementEnabled) {
        this.denialModal.open();
      }else {
        console.log("Creating new announcement");
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'announcementDetail', "tenderId": null } });
      }
    });
   
  }

  goToDetail(card: Announcement) {
    this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'announcementDetail', "tenderId": card.announcementId } });
  }

  isDetailVisible(statusCode: string) {
      return true;
    //return statusCode === 'DRAFT' || statusCode === 'ONGOING' || statusCode === 'DISCOUNT' || statusCode === 'DEAL' || statusCode === 'ACCEPTED';
  }

  loadClosedList() {
    this.openedAnnouncementCards = [];
    this.isHistoryView = true;
    let closedStatuses = "OFFER_REFUSED,OFFER_ACCEPTED";
    this.commonService.getAnnouncementsService().announcementGet(
			this.pageSize,
			this.pageNumber,
      null, 
      null,
      null, 
      closedStatuses
		).subscribe(
        (res: AnnouncementList) => {
          console.log('Current announcement: ' + JSON.stringify(res));
          this.closedAnnouncementCards =  this.closedAnnouncementCards.concat(res.announcements);
          this.showMore = res.paging.pageNumber < (res.paging.totalPages - 1);
          this.emptyLabel = "Nessun annuncio presente";
        },
        error => {
          console.error(error);
        }
      );
  }

  getProvincesAsString(announcement: Announcement) {
    console.log("Provinces: " + JSON.stringify(this.provinceList));
    let provincesAsString = "";
    this.provinceList.forEach(element => {
      if (announcement.provinces.includes(element.code)) {
        provincesAsString += element.description + ",";
      }
    });
    if (provincesAsString.length === 0) {
      return "Non specificato"
    }
    return provincesAsString.slice(0, -1);
  }
}
